import { _x } from '@wordpress/i18n';
import { scrollUpIcon } from './rlt-scroll-up-icon';

document.addEventListener('DOMContentLoaded', () => {
	const container = document.querySelector('.rlt-page-content');
	if (!container) {
		return;
	}

	const button = document.createElement('button');
	button.type = 'button';
	button.className = 'rlt-scroll-top-btn';
	button.setAttribute(
		'aria-label',
		_x(
			'Scroll to top',
			'Button label for scrolling page to the top',
			'gramm'
		)
	);
	button.innerHTML = scrollUpIcon;
	container.appendChild(button);

	const scrollThreshold = 500;
	let isVisible = false;

	const throttle = (fn, delay) => {
		let isThrottled = false;
		return (...args) => {
			if (!isThrottled) {
				fn(...args);
				isThrottled = true;
				setTimeout(() => (isThrottled = false), delay);
			}
		};
	};

	const updateButtonState = () => {
		const shouldBeVisible = window.scrollY > scrollThreshold;
		if (shouldBeVisible !== isVisible) {
			button.classList.toggle('show', shouldBeVisible);
			isVisible = shouldBeVisible;
		}
	};

	const scrollToTop = () => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	};

	const onScroll = throttle(updateButtonState, 100);
	window.addEventListener('scroll', onScroll);
	button.addEventListener('click', scrollToTop);
});
